import { render, staticRenderFns } from "./oa-clothing-fgb.vue?vue&type=template&id=747b2170"
import script from "./oa-clothing-fgb.vue?vue&type=script&lang=ts"
export * from "./oa-clothing-fgb.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports